import makeStyles from "@mui/styles/makeStyles";
import { Theme } from "@mui/material/styles";

const styles = makeStyles<Theme>((theme) => ({
  modalWidth: {
    width: "40vw",
    [theme.breakpoints.down("md")]: {
      width: "55vw",
    },
    [theme.breakpoints.down("sm")]: {
      width: "85vw",
    },
  },
  modalSection: {
    width: "100%",
  },
  separator: {
    margin: "12px 0px",
  },
}));

export default styles;
